import cn from 'classnames'
import Image from 'next/image'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { HOMEPAGE_REMOVE_ITEMS } from 'src/config/config'
import { IExpertCardDataFragment } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'
import { removeTags } from 'src/utils/removeTags'

interface Props {
  expert: IExpertCardDataFragment
  className?: string
}

export const ExpertCard: React.FC<Props> = ({ className, expert }) => {
  const avatar = useDefaultLogo(expert?.avatar?.url)
  const title = `${removeTags(expert?.title || '')}` || ''
  const displayName = `${removeTags(expert?.displayName || '')}` || ''
  return (
    <CompatibleLink
      href={`/experts/${expert?.slug}/`}
      passHref
      className="cursor-pointer flex flex-col items-center justify-center"
      tabIndex={-1}
    >
      <div
        className={cn(
          HOMEPAGE_REMOVE_ITEMS
            ? 'w-[100px] h-[100px] flex items-center justify-center overflow-hidden rounded-[60px] object-cover'
            : 'w-[120px] h-[120px] flex items-center justify-center overflow-hidden rounded-[60px] object-cover',
          className,
        )}
      >
        {HOMEPAGE_REMOVE_ITEMS ? (
          <Image
            src={avatar}
            alt={displayName}
            priority
            width={100}
            height={100}
            className={cn('w-[100px] h-[100px]')}
          />
        ) : (
          <Image
            src={avatar}
            alt={displayName}
            priority
            width={120}
            height={120}
            className={cn('w-[120px] h-[120px]')}
          />
        )}
      </div>
      {displayName &&
        (HOMEPAGE_REMOVE_ITEMS ? (
          <p className="font-secondary font-[700] md:text-[16px] text-[16px] leading-[24px] tracking-[0px] text-center text-[#011D58] mt-[13px]">
            {displayName}
          </p>
        ) : (
          <p className="font-secondary font-bold text-center text-textdark text-[1rem] mt-3">{displayName}</p>
        ))}
      {title &&
        (HOMEPAGE_REMOVE_ITEMS ? (
          <p className="font-secondary  font-[400]  md:text-[14px] text-[14px] leading-[21px] tracking-[0px] text-center text-[#333333]">
            {title}
          </p>
        ) : (
          <p className="font-secondary text-darkgray text-center text-[0.8rem]">{title}</p>
        ))}
    </CompatibleLink>
  )
}
